import { render, staticRenderFns } from "./background-parallax.vue?vue&type=template&id=929dd944&scoped=true&"
import script from "./background-parallax.vue?vue&type=script&lang=js&"
export * from "./background-parallax.vue?vue&type=script&lang=js&"
import style0 from "./background-parallax.vue?vue&type=style&index=0&id=929dd944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929dd944",
  null
  
)

export default component.exports